import React, { Component } from 'react';
import './../stylesheets/general.css';

class Footer extends Component {
    render() {
        return (
            <section>
                <div className="social-icons">
                    <a href="https://www.instagram.com/paraflux_games/" target="_blank" rel="noopener noreferrer">
                        <img className="icon" src={require('./../pics/icons/insta-icon.png')} alt="Instagram" />
                    </a>
                    <a href="https://www.youtube.com/@ParafluxGames/shorts/" target="_blank" rel="noopener noreferrer">
                        <img className="icon" src={require('./../pics/icons/yt-icon.png')} style={ {paddingTop: '5px'} } alt="Youtube" />
                    </a>
                    <a href="https://www.tiktok.com/@paraflux_games/" target="_blank" rel="noopener noreferrer">
                        <img className="icon" src={require('./../pics/icons/tiktok-icon.png')} alt="TikTok" />
                    </a>
                    <a href="https://bsky.app/profile/maxcj-paraflux.bsky.social/" target="_blank" rel="noopener noreferrer">
                        <img className="icon" src={require('./../pics/icons/bluesky-icon.png')} alt="Bluesky" />
                    </a>
                    <a href="https://x.com/MaxCJ_Paraflux/" target="_blank" rel="noopener noreferrer">
                        <img className="icon" src={require('./../pics/icons/x-icon.png')} alt="X" />
                    </a>
                    <a href="https://www.facebook.com/parafluxgames/" target="_blank" rel="noopener noreferrer">
                        <img className="icon" src={require('./../pics/icons/fb-icon.png')} alt="Facebook" />
                    </a>
                </div>
            </section>
        );
    }
}

export default Footer;